import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';


@Injectable({
   providedIn: 'root'
})
export class AuthService
{

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public get() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Auth`;
      return this.httpClient.get(url);
   }
   public logout() {
     let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Auth/LogOut`;
     return this.httpClient.get(url);
   }
}
